import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { handleKettoLinks, handlePledgeMoreLink, isMobile } from '../../../../services/helperFunctions';
import { sendEvents } from '../../../../redux/actions/Home';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '../../../public/images/icon-close.png';
import CloseIconWhite from '../../../public/images/closeIconWhite.png';
import CoverImgChild from '../../../public/images/bg-img.png';
import { SocialButton } from '../index';
import './popupCard.scss';
import { UserLoginContext } from '../../../../contexts/LoggedInUserContext';

export const PopupCard = ({
  type = 'default',
  highlight,
  highlightColor,
  description,
  descriptionColor,
  background,
  bgColor,
  bgColor1,
  bgColor2,
  cardDescription,
  cardDesc,
  closepopup,
  bgWidth,
  cardType,
  amount,
  newAmount,
  subscriptionData,
  isPledgeEnable,
  page,
}) => {
  const { userData, latestOrder } = useContext(UserLoginContext);
  const [shareModal, setShareModal] = useState(false);
  const { email } = userData;
  const campaign_cause = latestOrder;
  const handleShareIcon = () => {
    setShareModal(true);
  };

  const eventTrackingCta = (isChecking) => {
    if (isChecking === 'card1') {
      sendEvents('give_more', 'sip_returning_homepage', 'monthly_donors', 'impact', '', true);
    } else if (isChecking === 'card2') {
      sendEvents('give_more', 'sip_returning_homepage', 'kids_impact', 'impact', '', true);
    } else if (isChecking === 'card3') {
      sendEvents('give_more', 'sip_returning_homepage', 'contributed', 'impact', '', true);
    } else if (isChecking === 'card4') {
      sendEvents('give_more', 'sip_returning_homepage', 'proud_changemakers', 'impact', '', true);
    }
  };

  return (
    <div className="popup-card" style={{ backgroundColor: `${bgColor}` }}>
      {cardType === 'card4' ? (
        <>
          <div className="icon-close-m-web web-hide" onClick={closepopup}>
            <img
              src={CloseIconWhite}
              alt="close-icon"
              style={{ width: '12px', zIndex: '11' }} />
          </div>
          <div className="icon-close mob-hide" onClick={closepopup}>
            <img
              src={CloseIconWhite}
              alt="close-icon"
              style={{ width: '12px', zIndex: '11' }} />
          </div>
        </>
      ) : cardType === 'card2' ? (
        <>
          <div className="icon-close-m-web web-hide" onClick={closepopup}>
            <img
              src={CloseIconWhite}
              alt="close-icon"
              style={{ width: '12px', zIndex: '11' }} />
          </div>
          <div className="icon-close mob-hide" onClick={closepopup}>
            <img
              src={CloseIcon}
              alt="close-icon"
              style={{ width: '12px', zIndex: '11' }} />
          </div>
        </>
      ) : (
        <div className="icon-close" onClick={closepopup}>
          <img
                src={CloseIcon}
                alt="close-icon"
                style={{ width: '12px', zIndex: '11' }} />
        </div>
      )}
      {bgColor ? (
        <div>
          <div className="donor-highlight">
            <p className="donor-count">{highlight}</p>
            <p className="donor-title">{description}</p>
          </div>
          <div className="multiple-profile">
            <img
              className="img-no-one"
              src="https://i.imgur.com/y8Wbz7c.png"
              alt="img" />
            <img
              className="img-no-two"
              src="https://i.imgur.com/gqceVXk.png"
              alt="img" />
            <img
              className="img-no-three"
              src="https://i.imgur.com/MDPTnsg.png"
              alt="img" />
            <img
              className="img-no-four"
              src="https://i.imgur.com/bBPHoFh.png"
              alt="img" />
            <img
              className="img-no-five"
              src="https://i.imgur.com/jRifryF.png"
              alt="img" />
          </div>
        </div>
      ) : (
        <div className="backgroung-coverImg" style={{ background: bgColor1 }}>
          {cardType === 'card4' ? (
            <>
              <div className="mob-hide">
                <img
                    className="bg-img d-block m-auto"
                    src={background}
                    alt="cover-img"
                    style={{ width: bgWidth }} />
              </div>
              <div className="web-hide">
                <img
                    className="bg-img d-block m-auto"
                    src={background}
                    alt="cover-img"
                    style={{ width: "85%" }} />
              </div>
            </>
          ) : (
            <>
              <div className="mob-hide">
                <img
                      className="bg-img d-block m-auto"
                      src={background}
                      alt="cover-img"
                      style={{ width: bgWidth}} />
              </div>
              <div className="web-hide">
                <img
                      className="bg-img d-block m-auto"
                      src={CoverImgChild}
                      alt="cover-img"
                      style={{ width: bgWidth }} />
              </div>
            </>
          )}
          <div className={`${cardType === "card2" ? "CoverImg-title-card2" : "CoverImg-title"} ${isPledgeEnable && cardType === "card4" ? "adjustTop" : ""}`}>
            <p className="popup-cover-title">{highlight}</p>
            <p className="cover-desc-title" style={cardType === "card4" ? {fontSize: "20px"} : {}}>{description}</p>
          </div>
        </div>
      )}
      {bgColor ? (
        <>
          <div className="card-desc-title1">
            <p>{cardDescription}</p>
            <p>{cardDesc}</p>
          </div>
          <div className="btn-div">
            <Button
              className="share-btn"
              onClick={() => handleShareIcon()}>
              Share
            </Button>
            {isPledgeEnable
              && (
              <div class="pledgeMoreContainer"
                onClick={() => handlePledgeMoreLink(newAmount, amount, `${cardType == 'card1' ? 'monthly_donors' : 'contributed'}${window.pledgeMoreSlab ? '&slab=' + window.pledgeMoreSlab : ''}`, email, campaign_cause && campaign_cause.campaign_cause)}>
                <div onClick={() => eventTrackingCta(cardType)}>
                  <Button className="give-more-btn">Contribute more
                    <ArrowForwardIcon style={{marginLeft : "8px"}}/>
                  </Button>
                </div>
              </div>
              )}
          </div>
        </>
      ) : (
        <div className="bottom-bg" style={{ background: bgColor2 }}>
          <div className="card-desc-title">
            <p className="card-title mb-0" style={{ color: highlightColor }}>
              {cardDescription}
            </p>
          </div>
          <div className="btn-div">
            <Button
                className="share-btn"
                onClick={() => {
                  handleShareIcon();
                }}>
              Share
            </Button>
            {isPledgeEnable && (
              <div class="pledgeMoreContainer"
                onClick={() => handlePledgeMoreLink(newAmount, amount, `${cardType == '2' ? 'kids_impact' : 'proud_changemakers'}${window.pledgeMoreSlab ? '&slab=' + window.pledgeMoreSlab : ''}`, email, campaign_cause && campaign_cause.campaign_cause)}>
                <div onClick={() => eventTrackingCta(cardType)}>
                  <Button className="give-more-btn">Contribute more
                    <ArrowForwardIcon style={{marginLeft : "8px"}}/>
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <Modal open={shareModal} className="modal-center">
        <div className="socailButtonModal">
          <img
            src={CloseIcon}
            alt="close-icon"
            align="right"
            onClick={() => setShareModal(false)} />
          <div className="socailButton">
            <SocialButton
              cardType={cardType}
              type="facebook"
              text="Spread the word"
              action="share"
              page={page}
              btnWidth="116%" />
            <br />
            <SocialButton
              type="whatsapp"
              text="Spread the word"
              action="share"
              btnWidth="116%"
              btnMargin="12px"
              page={page}
              cardType={cardType} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PopupCard;
